module.exports = __webpack_public_path__ + "img/cuff width.6e53feb6.png";